import { isDefinedString } from "et3-type-guards";
import { TTableHeader } from "../../Types";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import { colors } from "../et3-theme/colors";
import Et3Margin from "../et3-ui/ET3Margin";

const TableTitle = withLiteObserverAndTheme<TTableHeader>((props) => {
  const { width, title } = props;
  return isDefinedString(title) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={width}
      height={56}
      fDirection={"row"}
      color={colors.all.transparent}
      style={{}}
      alignItems="flex-start"
      justifyContent="flex-start"
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={width / 2}
        height={36}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{}}
        alignItems="flex-start"
        justifyContent="flex-start"
        onClick={() => {}}
      >
        <Et3Margin left={20} right={0} top={0} bottom={0} />
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={20}
          text={title}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{}}
        />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default TableTitle;
